import React, { Component } from "react";
import FaqComponent from "react-faq-component";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import Header from "../../Content/Header/Header";
import { ENABLE_RESONATE_WEBSITE } from "../../../constants/Constants";

require("./FAQPage.scss");

const data = {
  title: "Frequently Asked Questions",
  rows: [
    {
      title: "What is NBCF & Resonate?",
      content:
        "<b>New Beginnings Christian Fellowship</b>, established in 2009, is a community of believers in Southern California who love Jesus and are passionate about mobilizing resources to support missions and projects in India. As of this year, we support 62 indigenous projects and missions."
    },
    {
      title: "What is the recommended donation for each token?",
      content:
        "Recommended donation is $2 per token. Please call or text us at <a href='tel:+19496566287'>949-656-6287</a> if you need additional clarifications."
    },
    {
      title: "How do I participate in Silent Auction?",
      content:
        "To participate in Silent Auction <br/><br/><ul><li>Click on Silent Auction link </li><li>Choose the item you want to bid on and place your bid</li><li>There are two sets of auction items:</li><ul><li><b>Set 1</b> – Bidding closes <b>15 minutes before the program ends.</b></li><li><b>Set 2</b> – Bidding closes <b>just a few minutes before the program ends.</b></li></ul><li>Click the heart (❤️) icon to add items to your favorites and view them at the top of your list.</li><li>You can turn on notifications on your phone to get alerts whenever someone places a higher bid than yours.</li><li>You can make repeated entries to outbid others</li><li>Click the refresh button to see the latest bids.</li><li>The silent auction results will be announced at the end of the Resonate program on May 3<sup>rd</sup>. </li></ul>"
    },{
      title: "What is Subscription Giving, and how do I sign up?",
      content: "Subscription giving is a way to regularly support NBCF missions through a monthly financial commitment. You can begin with a minimum donation of $25 per month and increase your giving at any time as you are led. <br/> <br/> To sign up, you can make a commitment on this website to contribute on a recurring basis. After submitting your commitment, you will receive an email with detailed instructions on how to activate your subscription through the NCF website."

    },
    {
      title: "What can I order on the website?",
      content:
        "We encourage everyone to join us on May 3<sup>rd</sup> in-person. You can order a very limited number of items/services on the website. <br/> We will not require you to make immediate payments when you order on the website or participate in the silent auction.  You can donate during the event."
    },
    {
      title: "How and when do I make payments?",
      content:
        "You are not required to make payments when you place the order on the website or use digital tokens. <br/> Once you complete your order, you will receive an email with the items ordered. <br/><br/>Purchase the tokens in-person during the Resonate event and collect the items."
    },
    {
      title: "How can I make additional donations?",
      content:
        "Many of you just make donations irrespective of what you order. You can continue to do so using the below options <ul><li>Click on the <b><a href='https://secure.ncfgiving.com/GXDonateNow?id=a0Ui0000007zz5OEAQ' target='_blank'>donate</a></b> button on the website</li><li>You can write a check in favor of 'NCF-NBCF Fund'</li><li>Use Venmo <b>(@NBCF-SoCal)</b> to make payment <ul><li>Venmo donations will be treated as cash donations</li></ul></li></ul>"
    },
    {
      title: "How can I set up regular giving for NBCF?",
      content: "Please follow the steps below: <ol><li>Go to the secure giving page: <a href='#' target='_blank' rel='noopener noreferrer'>Donate Now</a></li><li>Please enter your committed monthly contribution.</li><li>Select <strong>Monthly</strong> as your donation frequency. <br/> <img src='/subscription-faq.png' alt='Monthly donation selection example' width='600'></li><li>Choose your preferred start date (today or a future date).</li><li>(Optional) Leave the end date blank for ongoing giving.</li><li>Enter your contact information.</li><li>Add your payment method:<ul><li>Bank account (recommended to minimize fees)</li><li>Credit/Debit card</li></ul></li><li>Review your details and click <strong>Donate</strong>.</li></ol>"

    },
    {
      title:
        "What if I have additional questions or need additional clarifications?",
      content:
        "Please Call/Text us at <a href='tel:+19496566287'>949-656-6287</a>."
    }
  ]
};

class FAQPage extends Component {
  componentDidMount() {
    if (!checkCookie("emailId") || !(ENABLE_RESONATE_WEBSITE)) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="faq-container">
        <Header />
        <FaqComponent data={data} />
      </div>
    );
  }
}

export default FAQPage;
